// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgArrowUp24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M11.4697 4.21967C11.7626 3.92678 12.2374 3.92678 12.5303 4.21967L18.5303 10.2197C18.8232 10.5126 18.8232 10.9874 18.5303 11.2803L18.4462 11.3529C18.1526 11.5708 17.7359 11.5466 17.4697 11.2803L12.749 6.56L12.75 19.25C12.75 19.6297 12.4678 19.9435 12.1018 19.9932L12 20C11.5858 20 11.25 19.6642 11.25 19.25L11.249 6.562L6.53033 11.2803C6.26406 11.5466 5.8474 11.5708 5.55379 11.3529L5.46967 11.2803C5.17678 10.9874 5.17678 10.5126 5.46967 10.2197L11.4697 4.21967Z" />
			</Svg>
		);
	}
);
SvgArrowUp24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgArrowUp24;
